<template>
  <CContainer fluid>
    <CRow>
      <CCol col="6" sm="6">
        <CInput 
          label="Buscar:"
          addLabelClasses="text-muted font-weight-bold"
          :value.sync="searchWord" 
          @keyup.enter="getData(1, searchWord)">
          <template #prepend-content>
            <a href="#" @click="getData(1)">
              <i class="bi bi-arrow-clockwise"></i>
            </a>
          </template>
          <template #append-content>
            <a href="#" @click="getData(1, searchWord)">
              <i class="bi bi-search"></i>
            </a>
          </template>
        </CInput>
      </CCol>
      <CCol>
        <CButton
          color="success" 
          variant="outline" 
          class="mt-4"
          @click="(event) => openTrackingPanel(event)">
          <i class="bi bi-plus-circle h4 mr-2"></i>
          <span>Agregar</span>
        </CButton>
      </CCol>
    </CRow>
    <CDataTable 
      hover
      :fields="fields"
      :items="data"
      :items-per-page="itemsPerPage"
      :responsive="true">
      <template #seguimiento="{item}">
        <td>
          <div>
            <h4>{{ item.consecutivo }}</h4>
          </div>
          <div>
            <i class="bi bi-calendar3 mr-1"></i>
            <span>{{ moment(item.fecha_Hora).format("DD/MM/YYYY") }}</span>
          </div>
          <div>
            <i class="bi bi-clock mr-1"></i>
            <span>{{ moment(item.fecha_Hora).format("HH:MM") }}</span>
          </div>
        </td>
      </template>
      <template #responsable="{item}">
        <td>
          <div>
            <i class="bi bi-person-workspace mr-1"></i>
            <span>{{ item.empleado }}</span>
          </div>
          <div>
            <i class="bi bi-pin-angle mr-1"></i>
            <span>{{ item.clase_Seguimiento }}</span>
          </div>
        </td>
      </template>
      <template #comentario="{item}">
        <td>
          <div>
            <p>{{ item.comentarios }}</p>
          </div>
        </td>
      </template>
      <template #documento="{item}">
        <td>
          <div class="d-flex justify-content-end">
            <small class="text-muted">{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</small>
          </div>
          <div class="d-flex justify-content-end">
            <small class="text-muted">{{ moment(item.fecha_Creacion).format("HH:MM:SS") }}</small>
          </div>
        </td>
      </template>
    </CDataTable>
    <CPagination 
      size="sm" 
      class="d-flex justify-content-center" 
      :activePage.sync="page"
      :pages="pageCount"
      @update:activePage="(value) => getData(value, searchWord)">
    </CPagination>

    <RightSideBar class="bg-s3grey" :show="showPanelForm">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Seguimiento
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="trackingFields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success"
                @click="saveTracking()">
                <CIcon name="cil-check-circle"/>
                <span class="align-middle ml-2">Guardar</span>
                <CSpinner size="sm" class="align-middle mx-2" v-show="loadingSave" />
              </CButton>
              <CButton 
                color="danger" 
                variant="outline" 
                class="ml-2" 
                @click="showPanelForm = false" >
                <CIcon name="cil-x-circle"/>
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <CElementCover v-show="loading" />
  </CContainer>
</template>
<script>
  import moment from "moment";
  import CONSTANTS from "@/constants";
  import { formatter } from "@/general";
  import { dataListClasesSeguimientos } from '@/api';
  import { dataGridSeguimientos } from "@/apiDataGrids";
  import { crudSeguimiento } from "@/apiCRUD";
  
  import RightSideBar from '@/components/containers/RightSideBar.vue';
  import VerticalDynamicForm from '@/components/containers/VerticalDynamicForm.vue';

  const fields = [
    { key: "seguimiento", label: "Seguimiento", _style: "text-align:center" },
    { key: "responsable", label: "Empleado ", _style: "text-align:center" },
    { key: "comentario", label: "Comentario", _style: "text-align:center" },
    { key: "documento", label: "Documento", _style: "text-align:center" }
  ];

  const trackingFields = [
    {
      key: "trackingClass",
      label: "Clase Seguimiento:",
      value: "",
      type: "select",
      prepend_content: {
        name: "bookmark-check"
      },
      options: [],
      required: true
    },
    {
      key: "dateTracking",
      label: "Fecha:",
      value: moment().format("YYYY-MM-DD"),
      type: "date",
      prepend_content: {
        name: "calendar-date"
      },
      required: true
    },
    {
      key: "timeTracking",
      label: "Hora:",
      value: moment().format("HH:mm"),
      type: "time",
      prepend_content: {
        name: "clock"
      },
      required: true
    },
    {
      key: "comments",
      label: "Comentarios:",
      value: "",
      type: "textarea",
      prepend_content: {
        name: "chat-square-text"
      },
      required: true
    }
  ];

  export default {
    name: "BusinessTracking",
    data() {
      return {
        formatter,
        fields,
        trackingFields,
        dataTrackingClass: [],
        data: [],
        loading: false,
        loadingSave: false,
        showPanelForm: null,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: ""
      }
    },
    props: {
      IdEmployee: String,
      IdTrackingClass: String,
      IdDirectory: String,
      IdDependency: String,
      IdOpportunity: String,
      IdOrder: String,
      IdDocument: String,
      DateFilterType: String,
      InitDate: String,
      EndDate: String
    },
    setup() {
      
    },
    components: {
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        try {
          const { count, results } = await dataGridSeguimientos(
            this, 
            this.IdEmployee, 
            this.IdTrackingClass, 
            this.IdDirectory,
            this.IdDependency,
            this.IdOpportunity,
            this.IdOrder,
            this.IdDocument,
            this.DateFilterType,
            this.InitDate,
            this.EndDate,
            page,
            search
          );

          this.pageCount = parseInt(count / this.itemsPerPage);
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          }

          this.data = results
        } catch (error) {
          console.log(error);
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos!",
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async getTrackingClass() {
        try {
          const response = await dataListClasesSeguimientos(this);

          this.dataTrackingClass = [
            {
              label: "Seleccionar",
              value: ""
            },
            ...response.map(item => {
              return {
                label: item.descripcion,
                value: item.id_ClaseSeguimiento
              }
            })
          ]

          trackingFields[0].options = this.dataTrackingClass
        } catch (error) {
          console.error(error);
        }
      },
      async saveTracking() {
        this.loadingSave = true;

        try {
          const requestData = {
            personal: this.$store.state.user.data.id_Empleado,
            clase_Seguimiento: this.trackingFields[0].value,
            fecha_Hora: `${this.trackingFields[1].value}T${this.trackingFields[2].value}`,
            comentarios: this.trackingFields[3].value,
            estado: "N",
            directorio: this.IdDirectory,
            id_Usuario: this.$store.state.user.data.id_Usuario
          };

          await crudSeguimiento(this, "create", null, requestData);

          this.getData(1)
        } catch (error) {
          console.error(error);
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneAdd,
            show: 5
          })
        } finally {
          this.loadingSave = false;
          this.showPanelForm = null;
        }
      },
      openTrackingPanel(event) {
        event.stopPropagation();


        this.dataTrackingClass[0].value = "";

        this.showPanelForm = true
      }
    },
    mounted() {
      this.getData();
      this.getTrackingClass();
    }
  };
</script>
